import React from "react";
import { Tooltip } from "react-tooltip";
import { AiOutlineInfoCircle } from "react-icons/ai";

const Tips = ({ id, message }) => {
  return (
    <div className="tips-container">
      <AiOutlineInfoCircle
        className="info-icon"
        data-tooltip-id={id}
        data-tooltip-content={message}
      />
      <Tooltip id={id} place="top" effect="solid" />
    </div>
  );
};

export default Tips;
